module.exports = __webpack_public_path__ + "static/media/1POLICY11.52c625f0.jpg";